import React from 'react'
import { Box, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { isNil } from 'lodash'

import constants from 'constants/index'
import useStyles from './styles'

const Pill = ({ color, highlight, className, textClassName, children }) => {
  const classes = useStyles()

  const hasHighlight = !isNil(highlight)

  return (
    <Box className={clsx(classes.pill, classes[color], className)}>
      {hasHighlight && (
        <Typography className={classes.highlight}>{highlight}</Typography>
      )}
      <Typography
        className={clsx(
          classes.text,
          { [classes.textBesideHighlight]: hasHighlight },
          textClassName,
        )}
      >
        {children}
      </Typography>
    </Box>
  )
}

Pill.propTypes = {
  color: PropTypes.oneOf(Object.values(constants.dpoday.DPO_DAY_PILL_COLORS))
    .isRequired,
  highlight: PropTypes.node,
  className: PropTypes.string,
  textClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default Pill
